// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1_rU6","row":"ProcedureTreatmentSummary_row__1-PJ2"};